import {TreeNavigator} from '@ispm/shared/bpmn-io/services/tree-navigator';
import {PathwaysViewerCommands} from '@ispm/shared/bpmn-io/pathways-viewer-commands';
import CommandStack from 'diagram-js/lib/command/CommandStack';
import {NodeNameEditor} from '@ispm-client/modules/process-executor/bpmn/interceptors/node-name-editor';
import {Store} from '@ngrx/store';
import {State} from '../store';
import {GuideBoxOverlayBehaviour} from '@ispm/shared/bpmn-io/behavior/guide-box-overlay-behaviour';
import {CustomRenderer} from '@ispm/shared/bpmn-io/custom-renderer';
import {ShapeFocus} from '@ispm/shared/bpmn-io/services/shape-focus';
import {CustomTextRenderer} from '@ispm/shared/bpmn-io/text/custom-text-renderer';
import {NeighborhoodOverlayBehaviorOnExecution} from './interceptors/neighborhood-overlay-behavior-on-execution';
import {NodeVisibilityBehavior} from '@ispm/shared/bpmn-io/behavior/node-visibility-behavior';
import {ZoomService} from './services/zoom-service';
import {LazyLoadingExtensionModule} from '@ispm/shared/bpmn-io/lazy-loading-extension-module';
import {IEService} from '@ispm/shared/services/IE.service';
import {TreePathNavigator} from '@ispm-client/modules/process-executor/bpmn/services/tree-path-navigator';
import {DimNodesService} from "@ispm-client/modules/process-executor/bpmn/services/dim-nodes.service";
import {TreeToScreenFitter} from '@ispm/shared/bpmn-io/services/tree-to-screen-fitter';
import {DimensionsCalculator} from '@ispm/shared/bpmn-io/services/dimensions-calculator';
import Modeling from "diagram-js/lib/features/modeling/Modeling";
import RuleProvider from "diagram-js/lib/features/rules/RuleProvider";
import BpmnLayouter from "bpmn-js/lib/features/modeling/BpmnLayouter";
import {CustomCanvas} from "@ispm/shared/bpmn-io/CustomCanvas";

export function getExtensionModule(store$: Store<State>) {
    return {
        __init__: [
            'store$',
            'bpmnRenderer',
            'treeNavigator',
            'ieService',
            'treePathNavigator',
            'shapeFocus',
            'nodeOverlayBehavior',
            'guideBoxOverlayBehavior',
            'pathwaysViewerCommands',
            'commandStack',
            'defaultRenderer',
            'nodeNameEditor',
            'nodeVisibilityBehavior',
            'zoomService',
            'dimNodesService',
            'dimensionsCalculator',
            'treeToScreenFitter',
            'modeling',
            'rules',
            'layouter',
            'canvas'
        ],
        __depends__: [LazyLoadingExtensionModule],
        store$: ['value', store$],
        bpmnRenderer: ['type', CustomRenderer],
        treeNavigator: ['type', TreeNavigator],
        ieService: ['type', IEService],
        treePathNavigator: ['type', TreePathNavigator],
        shapeFocus: ['type', ShapeFocus],
        nodeOverlayBehavior: ['type', NeighborhoodOverlayBehaviorOnExecution],
        guideBoxOverlayBehavior: ['type', GuideBoxOverlayBehaviour],
        pathwaysViewerCommands: ['type', PathwaysViewerCommands],
        commandStack: ['type', CommandStack],
        defaultRenderer: ['type', Object],
        nodeNameEditor: ['type', NodeNameEditor],
        textRenderer: ['type', CustomTextRenderer],
        nodeVisibilityBehavior: ['type', NodeVisibilityBehavior],
        zoomService: ['type', ZoomService],
        dimNodesService: ['type', DimNodesService],
        dimensionsCalculator: ['type', DimensionsCalculator],
        treeToScreenFitter: ['type', TreeToScreenFitter],
        modeling: ['type', Modeling],
        rules: ['type', RuleProvider],
        layouter: ['type', BpmnLayouter],
        canvas: ['type',CustomCanvas]

    };
}
